<template>
    <v-tooltip
        v-if="showButtonTooltip"
        :text="tooltipText"
        location="top"
        content-class="custom-tooltip"
    >
        <template #activator="{ props }">
            <button
                :class="btnStyle"
                @click="executeMethod"
                :type="type"
                :disabled="isDisabled"
                v-bind="props"
                :data-cy="dataCy"
            >
                <span v-if="btnLoading">
                    <div class="lds-dual-ring"></div>
                </span>
                <span v-else :class="textStyle">
                    <v-icon
                        v-if="icon && iconPosition !== 'right'"
                        class="mr-1"
                        :icon="icon"
                    />
                    {{ text }}
                    <v-icon
                        v-if="icon && iconPosition === 'right'"
                        class="ml-1"
                        :icon="icon"
                    />
                </span>
            </button>
        </template>
    </v-tooltip>

    <button
        v-else
        :class="btnStyle"
        @click="executeMethod"
        :type="type"
        :disabled="isDisabled"
        :data-cy="dataCy"
    >
        <span class="btn-content-wrapper">
            <!-- Keep text for width but hide it when loading -->
            <span
                :class="textStyle"
                :style="{ visibility: btnLoading ? 'hidden' : 'visible' }"
            >
                <v-icon
                    v-if="icon && iconPosition !== 'right'"
                    class="mr-1"
                    :icon="icon"
                />
                {{ text }}
                <v-icon
                    v-if="icon && iconPosition === 'right'"
                    class="ml-1"
                    :icon="icon"
                />
            </span>
            <!-- Absolutely position the loader so it doesn't affect width -->
            <div
                v-if="btnLoading"
                class="lds-dual-ring"
                style="position: absolute"
            ></div>
        </span>
    </button>
</template>

<script setup lang="ts">
import { computed } from "vue";

const componentProps = defineProps<{
    btnStyle?: string;
    text?: string;
    textStyle?: string;
    disabled?: boolean;
    btnLoading?: boolean;
    type?: any;
    isDisabled?: boolean;
    showTooltip?: boolean;
    tooltipMessage?: string;
    dataCy?: string;
    icon?: string;
    iconPosition?: "left" | "right";
}>();

const showButtonTooltip = computed(() => componentProps.showTooltip ?? false);
const tooltipText = computed(
    () =>
        componentProps.tooltipMessage ??
        "You do not have permission to perform this action.",
);

const emit = defineEmits(["runMethod"]);
const executeMethod = () => {
    emit("runMethod");
};
</script>

<style scoped>
/** Changes Vuetify's v-tooltip settings */
:global(.custom-tooltip) {
    opacity: 1 !important;
    background-color: var(--gray-700) !important;
    border: 1px solid var(--gray-200) !important;
    color: var(--white) !important;
    transform: translate(-0.7rem -0.8rem);
}
</style>
